var map = {
	"./da.json": "826e",
	"./de.json": "b8e6",
	"./en.json": "6e56",
	"./fr.json": "33de",
	"./pl.json": "73cb",
	"./sv.json": "3987",
	"./zh-CN.json": "88e5",
	"./zh-TW.json": "f646"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a624";